module.exports = __webpack_public_path__ + "img/Robbi_halo.b0f639e6.png";